<div class="row">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info">Subscription Groups</h3>
  </div>
  <div class="col-sm-12 text-end alert">
      <a [routerLink]="['/batch/group/new',server_user_id,0]" class ="btn btn-primary"> <i class="fa fa-plus"></i> Add New Group</a>
  </div>
</div>
<app-listing-group *ngIf="subscriptionGroupList"
 [subscriptionGroupList]="subscriptionGroupList"
 [server_user_id]="server_user_id"></app-listing-group>

<app-spinner *ngIf="!subscriptionGroupList"></app-spinner>
<div *ngIf="subscriptionGroupList && !loading" class="text-center">No Records Found </div>

<hr/>
<div class="text-center" >
  <a [routerLink]="['/batch/group/new',server_user_id,0]">Add New Subscription Group</a>
</div>


